/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockItemDto as DigiworkMaitreDPosDtoStockItemStockItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';

export interface GetStockItem$Params {
  stockItemId: string;
}

export function getStockItem(http: HttpClient, rootUrl: string, params: GetStockItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>> {
  const rb = new RequestBuilder(rootUrl, getStockItem.PATH, 'get');
  if (params) {
    rb.path('stockItemId', params.stockItemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>;
    })
  );
}

getStockItem.PATH = '/api/stock-items/{stockItemId}';
